__turbopack_context__.v({
  "container": "condensed-browse-course-card-module-scss-module__tTYica__container",
});
